import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=5e40ee5e"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=5e40ee5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports